// ProfileNavigation helper functions and data
import React from "react";

import CONSTANTS from "config/constants";
import { ProfileNavigationTab } from "./ProfileNavigation.types";

import OrdersSVG from "../../../../public/assets/images/orders.svg";
import HeartLineSVG from "../../../../public/assets/images/heart-line.svg";
import StoreSVG from "../../../../public/assets/images/store.svg";
import EditSVG from "../../../../public/assets/images/edit.svg";
import LocationSVG from "../../../../public/assets/images/location-filled.svg";
import NotificationsSVG from "../../../../public/assets/images/notifications.svg";
import ConfigSVG from "../../../../public/assets/images/config.svg";
import BillSVG from "../../../../public/assets/images/bill.svg";
import TermsSVG from "../../../../public/assets/images/terms.svg";
import SupportSVG from "../../../../public/assets/images/support.svg";
import HelpSVG from "../../../../public/assets/images/help.svg";

const { FEATURE_FLAGS } = CONSTANTS;
const { WITH_WISHLIST, WITH_DELIVERY } = FEATURE_FLAGS;
const { WITH_PURCHASE, WITH_DARK_MODE } = FEATURE_FLAGS;
export const tabs: (ProfileNavigationTab | null)[] = [
  WITH_PURCHASE
    ? {
        icon: <OrdersSVG className="ProfileNavigation__tab-icon" />,
        tabName: "Mis ordenes",
        isExternal: false,
        url: "/profile/orders",
        isPublic: true
      }
    : null,
  WITH_WISHLIST
    ? {
        icon: <HeartLineSVG className="ProfileNavigation__tab-icon" />,
        tabName: "Lista de deseos",
        isExternal: false,
        url: "/profile/wishlist",
        isPublic: false
      }
    : null,
  {
    icon: <StoreSVG className="ProfileNavigation__tab-icon" />,
    tabName: "Locales",
    isExternal: false,
    url: "/profile/stores",
    isPublic: true
  },
  {
    icon: <EditSVG className="ProfileNavigation__tab-icon" />,
    tabName: "Editar perfil",
    isExternal: false,
    url: "/profile/user",
    isPublic: false
  },
  {
    icon: <NotificationsSVG className="ProfileNavigation__tab-icon" />,
    tabName: "Notificaciones",
    isExternal: false,
    url: "/profile/notifications",
    isPublic: false
  },
  WITH_PURCHASE
    ? {
        icon: <BillSVG className="ProfileNavigation__tab-icon" />,
        tabName: "Datos de facturación",
        isExternal: false,
        url: "/profile/billing",
        isPublic: false
      }
    : null,
  WITH_DELIVERY
    ? {
        icon: <LocationSVG className="ProfileNavigation__tab-icon" />,
        tabName: "Direcciones",
        isExternal: false,
        url: "/profile/addresses",
        isPublic: false
      }
    : null,
  {
    icon: <TermsSVG className="ProfileNavigation__tab-icon" />,
    tabName: "Términos legales",
    isExternal: false,
    url: "/terms",
    isPublic: true
  },
  WITH_DARK_MODE
    ? {
        icon: <ConfigSVG className="ProfileNavigation__tab-icon" />,
        tabName: "Configuración",
        isExternal: false,
        url: "/profile/settings",
        isPublic: true
      }
    : null,
  {
    icon: <SupportSVG className="ProfileNavigation__tab-icon" />,
    tabName: "Contactar con soporte",
    isExternal: false,
    url: "/profile/support",
    isPublic: true
  },
  {
    icon: <HelpSVG className="ProfileNavigation__tab-icon" />,
    tabName: "Preguntas frecuentes",
    isExternal: false,
    url: "/profile/faq",
    isPublic: true
  }
];
